import { render, staticRenderFns } from "./TradeView.vue?vue&type=template&id=7fd0837b"
import script from "./TradeView.vue?vue&type=script&lang=js"
export * from "./TradeView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports